import React, { useState, useCallback } from 'react';
import { faEllipsis } from '@fortawesome/pro-solid-svg-icons/faEllipsis';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ColorPicker } from 'ui-components/components/color-picker';
import { ColorService } from 'ui-components/services/color-service';

import { useUpdateBrandingContext } from '../context';
import style from './style.module.less';

const CustomColorInput = ({ availableColors, value = '', onChange, field, onValidateError }) => {
  const { updateErrors } = useUpdateBrandingContext();
  const [hasError, setHasError] = useState(false);
  const onTextChange = (event) => onChange(field, event.target.value);

  const validateColor = useCallback(
    (colorValue) => {
      const hexHasError = !ColorService.isValidHexCode(colorValue);
      setHasError((prevHasError) => (hexHasError !== prevHasError ? hexHasError : prevHasError));
      updateErrors(field, hexHasError);
      onValidateError(hexHasError, field);
    },
    [field, updateErrors, onValidateError],
  );

  const onInputBlur = () => validateColor(value);
  const onColorPickerChange = useCallback(
    (colorValue) => {
      validateColor(colorValue);
      onChange(field, colorValue);
    },
    [field, onChange, validateColor],
  );

  return (
    <div className={style['color-picker-container']}>
      <div className={style['color-input']}>
        <div className={style['color-swatch-container']}>
          <ColorPicker
            colors={availableColors}
            compactIcon={faEllipsis}
            isCompact
            menuPosition='bottom-right'
            onChange={onColorPickerChange}
            value={value}
          />
        </div>
        <input
          className={classnames(style['color-input-element'], {
            [style['input-has-error']]: hasError,
          })}
          onBlur={onInputBlur}
          onChange={onTextChange}
          value={value}
        />
      </div>
      {hasError ? (
        <div className={style['error-message']}>
          <FormattedMessage
            defaultMessage='This is not a valid color hex code'
            description='Error message for invalid hex code'
            id='9moFH/'
          />
        </div>
      ) : null}
    </div>
  );
};

CustomColorInput.propTypes = {
  availableColors: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onValidateError: PropTypes.func.isRequired,
  field: PropTypes.string.isRequired,
};

export default CustomColorInput;
